import {
  CREATE_PROJECT_NOTE_FAIL,
  CREATE_PROJECT_NOTE_REQUEST,
  CREATE_PROJECT_NOTE_SUCCESS,
  DELETE_PROJECT_NOTE_FAIL,
  DELETE_PROJECT_NOTE_REQUEST,
  DELETE_PROJECT_NOTE_SUCCESS,
  DETAIL_MCU_PROJECT_NOTE_FAIL,
  DETAIL_MCU_PROJECT_NOTE_REQUEST,
  DETAIL_MCU_PROJECT_NOTE_SUCCESS,
  LIST_MCU_PROJECT_NOTE_FAIL,
  LIST_MCU_PROJECT_NOTE_REQUEST,
  LIST_MCU_PROJECT_NOTE_SUCCESS,
  UPDATE_PROJECT_NOTE_STATUS_FAIL,
  UPDATE_PROJECT_NOTE_STATUS_REQUEST,
  UPDATE_PROJECT_NOTE_STATUS_SUCCESS
} from '../../constants/mcu-project-note'

const initialState = {
  loading: false,
  loadingUpdate: false,
  loadingStatus: false,
  loadingDelete: false,
  loadingDetail: false,
  mcuProjectNote: [],
  detailMcuProjectNote: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_NOTE_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_NOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectNote: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_NOTE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectNote: action?.dummy
      }
    case UPDATE_PROJECT_NOTE_STATUS_REQUEST:
      return { ...state, loadingStatus: true }
    case UPDATE_PROJECT_NOTE_STATUS_SUCCESS:
      return {
        ...state,
        loadingStatus: false
      }
    case UPDATE_PROJECT_NOTE_STATUS_FAIL:
      return {
        ...state,
        loadingStatus: false
      }
    case CREATE_PROJECT_NOTE_REQUEST:
      return { ...state, loadingUpdate: true }
    case CREATE_PROJECT_NOTE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false
      }
    case CREATE_PROJECT_NOTE_FAIL:
      return {
        ...state,
        loadingUpdate: false
      }
    case DELETE_PROJECT_NOTE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PROJECT_NOTE_SUCCESS:
      return {
        ...state,
        loadingDelete: false
      }
    case DELETE_PROJECT_NOTE_FAIL:
      return {
        ...state,
        loadingDelete: false
      }
    case DETAIL_MCU_PROJECT_NOTE_REQUEST:
      return { ...state, loadingDetail: true, detailMcuProjectNote: {} }
    case DETAIL_MCU_PROJECT_NOTE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailMcuProjectNote: action.payload
      }
    case DETAIL_MCU_PROJECT_NOTE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        detailMcuProjectNote: {}
      }
    default:
      return state
  }
}

export default mcuProjectNoteReducer
